import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Youtube, Instagram } from "lucide-react";
import { SCHOOL } from "../data/siteData";
import "./Footer.css";

const SOCIAL = [
  { Icon: Facebook, label: "Facebook", href: "https://facebook.com", color: "#22499f" },
  { Icon: Twitter, label: "Twitter", href: "https://twitter.com", color: "#00a2f4" },
  { Icon: Youtube, label: "YouTube", href: "https://youtube.com", color: "#fe0002" },
  { Icon: Instagram, label: "Instagram", href: "https://instagram.com", color: "#fd0389" },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        {/* Row 1 */}
        <div className="footer__row footer__row--links">
          <div className="footer__col">
            <h4>About IDPS Mahore</h4>
            <ul>
              <li><Link to="/about">About IDPS Mahore</Link></li>
              <li><Link to="/mission-vision">Mission & Vision</Link></li>
              <li><Link to="/aim-objective">Aim & Objective</Link></li>
              <li><Link to="/admissions">Admissions</Link></li>
              <li><Link to="/academics">Academics</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
            </ul>
          </div>
          <div className="footer__col">
            <h4>Campus</h4>
            <ul>
              <li><Link to="/campus">Digital Classrooms</Link></li>
              <li><Link to="/campus">Library</Link></li>
              <li><Link to="/campus">Auditorium</Link></li>
              <li><Link to="/campus">AC Classrooms</Link></li>
              <li><Link to="/campus">Activity Rooms</Link></li>
              <li><Link to="/campus">Transport Facility</Link></li>
            </ul>
          </div>
          <div className="footer__col">
            <h4>Help & Support</h4>
            <ul>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/contact">Enquiry Form</Link></li>
              <li><Link to="/admissions">Admission Guidelines</Link></li>
              <li><Link to="/life-at-idps">Life @ IDPS</Link></li>
              <li><Link to="/gallery">Photo Gallery</Link></li>
            </ul>
          </div>
        </div>

        {/* Row 2 */}
        <div className="footer__row footer__row--info">
          <div className="footer__col">
            <h4>Get In Touch</h4>
            <p>Address: {SCHOOL.address}</p>
            <p className="footer__strong">
              Phone:{" "}
              <a href={`tel:${SCHOOL.phone}`}>{SCHOOL.phone}</a>
            </p>
            <p>
              Email: <a href={`mailto:${SCHOOL.email}`}>{SCHOOL.email}</a>
            </p>
          </div>
          <div className="footer__col">
            <h4>Quick Links</h4>
            <ul className="footer__inline-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/admissions">Admissions</Link></li>
              <li><Link to="/academics">Academics</Link></li>
              <li><Link to="/campus">Campus</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer__col">
            <h4>Social Media</h4>
            <ul className="footer__social">
              {SOCIAL.map(({ Icon, label, href, color }) => (
                <li key={label}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    style={{ backgroundColor: color }}
                  >
                    <Icon size={17} color="#fff" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        Copyright © 2026 {SCHOOL.name}, Mahore. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
